<template>
    <nav class="menu" :class="{'is_open' : isOpen}">
        <ul class="menu__list">
            <li class="menu__item">
                <router-link to="/products" class="menu__link" data-hover="Products">Products</router-link>
            </li>
            <li class="menu__item">
                <router-link to="/projects" class="menu__link" data-hover="Projects">Projects</router-link>
            </li>
            <li class="menu__item">
                <router-link to="/designers" class="menu__link" data-hover="Designers">Designers</router-link>
            </li>
            <li class="menu__item">
                <router-link to="/tour" class="menu__link" data-hover="Take a tour">Take a tour</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        data() {
            return {
                isOpen: false
            };
        },
    };
</script>


<style scoped lang="scss">
    
</style>